import CookiesModel from './cookies-model';
import CookiesView from './cookies-view';

export default class CookiesPresenter {
  constructor(view, appInterface) {
    this.model = new CookiesModel();
    this.view = view || new CookiesView();
    this.appInterface = appInterface || this.createDefaultAppInterface();
  }

  createDefaultAppInterface() {
    return {
      navigateBack: () => {
        if (window.history && window.history.length > 1) {
          window.history.back();
        } else if (window.app && window.app.navigateTo) {
          window.app.navigateTo('home');
        }
      },
      reinitTooltips: () => {
        if (window.app && window.app.tooltip && window.app.tooltip.reinit) {
          window.app.tooltip.reinit();
        }
      }
    };
  }

  async init() {
    this.renderPageContent();
    this.setupEventListeners();
  }

  renderPageContent() {
    const pageData = this.model.getPageData();
    const policyContent = this.model.getPolicyContent();
    
    this.view.renderPageHeader(pageData);
    this.view.renderContent(policyContent);
    
    this.appInterface.reinitTooltips();
  }

  setupEventListeners() {
    this.view.setupBackButtonEventListener(() => this.handleBackClick());
  }

  handleBackClick() {
    this.appInterface.navigateBack();
  }

  cleanup() {
    this.view.cleanup();
  }
}